import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import DialogContent from "@material-ui/core/DialogContent";
import moment from "moment";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DialogActions } from "@material-ui/core";

const FullTextDialog = ({ open, onClose, headerText, bodyText, date }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="Dialog"
      maxWidth="lg"
    >
      <DialogTitle disableTypography>
        <Typography variant="body2" color="primary">
          {moment(date).format("LLL")}
        </Typography>
        <Typography variant="h6" color="textPrimary">
          {headerText}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ minWidth: 350 }}>
        <Typography
          variant="body2"
          color="textPrimary"
          dangerouslySetInnerHTML={{
            __html: bodyText,
          }}
        />
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default FullTextDialog;
